import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import ExpandToggle from "@threespot/expand-toggle";
import MedicationsInfo from "./MedicationsInfo";

import Icon from "../Icon";

import { notDiseaseFund } from "../../helpers/fund";

const sortMedsByName = (medications) => {
  return medications.sort(
    (a, b) =>
      (a.Name.toLowerCase() > b.Name.toLowerCase()) -
      (a.Name.toLowerCase() < b.Name.toLowerCase())
  );
};

const DiseaseFundMeds = ({ medications, groupId }) => {
  const expandEl = useRef(null);
  const expandableEl = useRef(null);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (expandEl.current) {
      const toggle = new ExpandToggle(expandEl.current);

      toggle.on("expand", () => {
        setExpanded(true);
      });
    }
  });

  return (
    <div className="Stratum l-padding bg-white u-relative">
      <div className="l-wrap">
        <h2 className="f-h2 u-mb4">
          {notDiseaseFund(groupId) ? "Services" : "Medications"} Covered
          <span style={{ marginLeft: "12px" }}>
            <MedicationsInfo />
          </span>
        </h2>
        <div className="Glossary Glossary--compact">
          <ol
            ref={expandableEl}
            id="diseaseFundMedications"
            data-expands-height
            data-expands-class="is-expanded"
            className="Glossary-items"
          >
            {sortMedsByName(medications).map((medication, i) => (
              <li key={i} className="Glossary-item">
                <span className="Glossary-label">{medication.Name}</span>
              </li>
            ))}
          </ol>

          {!expanded && (
            <button
              className="Glossary-expand"
              type="button"
              ref={expandEl}
              data-expands="diseaseFundMedications"
            >
              <span className="Glossary-expand-iconWrapper">
                <Icon
                  className="Glossary-expand-icon"
                  width="20"
                  height="20"
                  name="plus"
                />
              </span>
              Show All
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

DiseaseFundMeds.propTypes = {
  medications: PropTypes.array.isRequired,
};

export default DiseaseFundMeds;
